<template>
		<div class="job-selector">
			<div class="job-selector-header tw-text-center">
					<info-icon v-if="showInfoIcon" class="info-icon" @click="$emit('infoClick')" />
					<h4 class="tw-mb-2">Puesto / {{ selectedJob.name }}</h4>
					<p class="tw-mb-0" v-html='cardDescription'></p>
			</div>
			<div class="job-selector-body">
				<guideline-job-verbs-selector
					v-show="currentPage === 1"
					:verbs-info="verbsSelection"
					:selected-job="selectedJob"
					@selectedJobDataChanged="$emit('selectedJobDataChanged', $event)"
				/>
				<guideline-job-level-selector
					:level-info="levelSelection"
					:selected-job="selectedJob"
					v-show="currentPage === 2"
					@selectedJobDataChanged="$emit('selectedJobDataChanged', $event)"
				/>
			</div>
			<guideline-job-selector-navigation
				:current-page="currentPage"
				@prevPageClick="prevLocalPage"
				@nextPageClick="nextLocalPage"
				@prevItemClick="onPrevClick"
				@nextItemClick="onNextClick"
				:job-list-navigation="jobListNavigation"
				:selected-next="selectedNext"
				:selected-prev="selectedPrev"
			/>
			<div class="job-selector-footer tw-text-center">
				<slot name="action-footer" />
			</div>
		</div>
</template>

<script>
import GuidelineJobVerbsSelector
	from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-verbs-selector';
import GuidelineJobLevelSelector
	from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-level-selector';
import InfoIcon from '@/modules/shared/components/icons/info-icon';
import { mapState } from 'vuex';
import { path } from 'ramda';
import GuidelineJobSelectorNavigation
	from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-selector-navigation';

export default {
	name: 'guideline-job-selector',
	components: {
		GuidelineJobSelectorNavigation,
		InfoIcon,
		GuidelineJobLevelSelector,
		GuidelineJobVerbsSelector,
	},
	props: {
		selectedJob: { default: () => ({}) },
		selectedPrev: { default: () => ({}) },
		selectedNext: { default: () => ({}) },
		jobListNavigation: { default: false },
		showInfoIcon: { default: false },
	},
	computed: {
		...mapState('jobEvaluation', {
			verbsSelection: path(['supplies', 'guidelineModel', 'verbsSelection']),
			levelSelection: path(['supplies', 'guidelineModel', 'levelSelection']),
		}),
		cardDescription() {
			const jobName = `<span style='text-transform: uppercase'>${this.selectedJob.name}</span>`;
			return this.currentPage === 1 ?
				`Marca los verbos que realiza el puesto de ${jobName}` :
				`Marca los niveles que realiza el puesto de ${jobName}`;
		},
	},
	data() {
		return {
			currentPage: 1,
		};
	},
	methods: {
		nextLocalPage() {
			this.currentPage = 2;
		},
		prevLocalPage() {
			this.currentPage = 1;
		},
		onPrevClick() {
			this.nextLocalPage();
			this.$emit('prevClick');
		},
		onNextClick() {
			this.prevLocalPage();
			this.$emit('nextClick');
		},
	},
};
</script>

<style lang='scss' scoped>
.job-selector {
	border-radius: 10px;
	border: solid 1px var(--app-color-gray);
	background-color: #ffffff;
	.job-selector-header {
		padding: 20px;
		position: relative;
		cursor: pointer;
		h4 {
			color: var(--app-color-primary);
			text-transform: uppercase;
			font-size: 16px;
		}
		p {
			font-size: 12px;
			color: #494949;
			span {
				text-transform: uppercase;
			}
		}
		.info-icon {
			position: absolute;
			top: 10px;
			right: 10px;
			z-index: 1;
			svg, path {
				fill: var(--app-color-primary);
			}
		}
	}
	.job-selector-body {
		min-height: 300px;
	}
	.job-selector-footer {
		padding: 20px;
		p {
			color: #9b9b9b;
			font-size: 12px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-selector.vue